<template>
    <v-card>
        <v-row cols="3">
            <v-col class="mx-4 py-0">
                <v-card-title class="justify-center">Overview of ski area's</v-card-title>
            </v-col>
        </v-row>
        <v-divider/>
        <v-card-text>
            <v-row cols="12">
                <v-col class="pt-2" cols=2>
                    <v-text-field v-model="search" label="Search ski area" single-line hide-details dense prepend-icon="mdi-magnify"></v-text-field>
                </v-col>
                <v-col class="pt-2" cols=1>
                    <v-select v-model="country" label="Country" :items="country_items" item-value="value" item-text="label" dense @change="updateCountry"></v-select>
                </v-col>
                <v-col class="pt-2" cols=6>
                    
                </v-col>
                <v-col class="pt-2" cols=2>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        components: {
        },    
        data() {
            return {
                search: "",

                country: "",
                country_items:[{
                    value: "",
                    label: "All"
                }, {
                    value: "AT",
                    label: "AT"
                }, {
                    value: "BE",
                    label: "BE"
                }, {
                    value: "DE",
                    label: "DE"
                }, {
                    value: "FR",
                    label: "FR"
                }, {
                    value: "NL",
                    label: "NL"
                }],
            }
        }, 
        watch: {
            search() {
                this.updateSearch();
            }
        },   
        methods: {
            updateSelection(selectionType, selectionValue) {
                this.$emit("updateSelection", selectionType, selectionValue);
            },  
            updateSearch() {
                this.updateSelection("search", this.search);
            },  
            updateCountry() {
                this.updateSelection("country", this.country);
            }, 
            refreshList() {
                this.updateSelection("refresh", "");
            },
        }
    }
</script>

<style scoped> 

</style>